import * as React from 'react';
import classnames from 'classnames';
import CheckboxWithLabel from '../CheckboxWithLabel/CheckboxWithLabel.js';

/**
 * This CheckBoxList uses the new CheckboxWithLabel.
 * Use this component in favour of the CheckboxList from the common package.
 * The old CheckboxList has been used as a base for this new component. They are very similar.
 */ const CheckboxList = function({ idPrefix , items , selectedItems , getItemIdentifier , renderItem , onChange , isItemDisabled , checkboxAlignment ='top' , className , itemClassName , getItemErrorMessage , shouldItemValidate  }) {
    const handleChange = React.useCallback(({ value , checked  })=>{
        if (!onChange) {
            return;
        }
        const newValues = checked ? [
            ...selectedItems,
            value
        ] : selectedItems.filter((i)=>getItemIdentifier(i) !== getItemIdentifier(value)
        );
        onChange(newValues);
    }, [
        selectedItems,
        getItemIdentifier,
        onChange
    ]);
    return /*#__PURE__*/ React.createElement("fieldset", {
        className: classnames('checkbox-list', className)
    }, items.map((item)=>{
        const id = idPrefix + String(getItemIdentifier(item));
        const isSelected = selectedItems.some((i)=>getItemIdentifier(i) === getItemIdentifier(item)
        );
        const isDisabled = isItemDisabled === null || isItemDisabled === void 0 ? void 0 : isItemDisabled(item);
        return /*#__PURE__*/ React.createElement("div", {
            key: id,
            className: classnames('checkbox-list__item', itemClassName)
        }, /*#__PURE__*/ React.createElement("div", {
            className: `checkbox-list__item-checkbox checkbox-list__item-checkbox--${checkboxAlignment}`
        }, /*#__PURE__*/ React.createElement(CheckboxWithLabel, {
            label: renderItem(item),
            id: id,
            value: item,
            checked: isSelected,
            disabled: isDisabled,
            onChange: handleChange,
            errorMessage: getItemErrorMessage && getItemErrorMessage(item),
            error: !isSelected && (shouldItemValidate === null || shouldItemValidate === void 0 ? void 0 : shouldItemValidate(item))
        })));
    }));
};

export { CheckboxList as default };
//# sourceMappingURL=CheckboxList.js.map
